import React from 'react';
import { useEffect, useState } from "react";

import Table from 'react-bootstrap/Table';
import { Col, Container } from 'react-bootstrap';
import { ApiDelete, ApiGet } from '../../helper/API/ApiData';
import { useNavigate, useParams } from 'react-router-dom';
import { cleanData, getHeading } from '../../utils/helper';
import swal from 'sweetalert';
import { toast } from 'react-toastify';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { useSelector } from 'react-redux';


type GroupMemberTraining = {
    groupDetail: {
        isActive: boolean
    }
    id: string
}

export const GroupMemberTrainings = (props: any) => {
    const navigate = useNavigate()
    const { group_member_id } = useParams();

    const [groupMemberTrainings, setGroupMemberTrainings] = useState<GroupMemberTraining[]>([])
    const groupMemberDetails = useSelector((store: any) => store.groupMemberDetail.groupMemberDetails)

    useEffect(() => {

        if (groupMemberDetails === null) {
            navigate('?page=home')
        }

        ApiGet(`group_member/${group_member_id}/trainings`)
            .then((res: any) => {
                if (res && res.status === 200) {
                    if (res && res.data) {
                        setGroupMemberTrainings(res.data)
                    }
                }
            })
    }, [])


    const handleUpdate = (groupMemberTrainingsId: string): void => {
        navigate(`?page=training&action=update&id=${groupMemberTrainingsId}`)
    }

    const handleDelete = (groupMemberTrainingsId: string): void => {
        swal({
            title: "Are you sure?",
            text: "you want to delete SHG?",
            icon: "error",
            buttons: ["cancel", "ok"],
            dangerMode: true,
        }).then((result) => {
            if (result) {
                ApiDelete(`group_member/${group_member_id}/trainings/${groupMemberTrainingsId}`, {})
                    .then((res: any) => {
                        if (res.status === 200) {
                            toast.success("Successfully deleted the shg")
                            setGroupMemberTrainings(groupMemberTrainings => groupMemberTrainings.filter(groupTraining => groupTraining.id !== groupMemberTrainingsId))
                            // Refetch the shg list
                            // setDeletedShgs(!deletedShgs)
                        }
                    })
                    .catch((error) => { return error })
            }
        })
    }

    const header = () => (

        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
            <span className="text-xxl text-900 font-bold">Trainings & Credit Info</span>
            {groupMemberDetails.isActive &&
                <Button icon="pi pi-plus" outlined style={{ borderRadius: "50%" }} onClick={() => navigate(`?page=training&action=add`)} />
            }
        </div>
    );

    const actionBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <Button icon="pi pi-pencil" style={{ borderRadius: "50%" }} rounded outlined className="mr-2" onClick={() => handleUpdate(rowData.id)} />
                <Button icon="pi pi-trash" style={{ borderRadius: "50%", marginLeft: "10px" }} rounded outlined severity="danger" onClick={() => handleDelete(rowData.id)} />
            </React.Fragment>
        )
    };

    const shgTrainingBodyTemplate = (rowData: any) => {
        return (
            <React.Fragment>
                <p>{rowData.shg_training.name_of_trainer} {new Date(rowData.shg_training.start_timestamp).toLocaleString()} to {new Date(rowData.shg_training.end_timestamp).toLocaleTimeString()}</p>
            </React.Fragment>
        )
    }

    return (
        <DataTable value={groupMemberTrainings} header={header}>
            <Column  body={shgTrainingBodyTemplate} key={"shg_training"} field={"shg_training"} header={getHeading("shg_training")}></Column>
            {groupMemberTrainings.length > 0 && Object.keys(groupMemberTrainings[0]).map((groupMemberTrainingsField, index) => {
                if (groupMemberTrainingsField !== 'id' && groupMemberTrainingsField !== 'shg_training' && groupMemberTrainingsField !== 'groupDetail') {
                    return (
                        <Column  key={groupMemberTrainingsField} field={groupMemberTrainingsField} header={getHeading(groupMemberTrainingsField)}></Column>
                    )
                }
            })}

            {groupMemberDetails.isActive &&
                <Column body={actionBodyTemplate} style={{ minWidth: '12rem' }} bodyStyle={{ textAlign: 'center' }}></Column>
            }
        </DataTable>
    )
};